export default __webpack_public_path__ + "static/media/wanna6.69424627.png";